<template>
  <div id="app">
    <div id="loading">
      <div id="preloader" class="animated-middle">
				<img src="img/logo3.png" alt="" class="loading-logo" />

				<span class="loading-text">Wczytywanie strony</span>

				<span class="load">
					<span class="loading-dot"></span>
					<span class="loading-dot"></span>
					<span class="loading-dot"></span>
					<span class="loading-dot"></span>
				</span>

			</div>
		</div>
    	<!-- +++ START - MultiScroll sections +++ -->
		<div id="multi-div">

			<!-- OPEN - LEFT PART -->
			<div class="ms-left">

				<!-- +++ START - Home Left +++ -->
				<div class="ms-section" id="left1">

					<!-- Your logo -->
	        		<img src="img/logo3.png" alt="" class="home-logo" />

					<!-- Background slideshow & light overlay -->
					<div class="slideshow-home-left">
						<div class="slideshow-overlay-left"></div>
					</div>

					<div class="intro">

						<!-- Big title  -->
						<h1 class="open-anim opacity-0"><strong>WITAJ W CENTRUM PROFIL</strong></h1>
            <p class="open-anim opacity-0" style="text-align: center;">Od stycznia zapraszamy pod nowy adres: <strong>ul. Narutowicza 94 lokal 8 </strong></p>


						<p class="open-anim opacity-0" style="text-align: center;">Jesteśmy profesjonalną pracownią <strong>psychologii pracy</strong></p>

						<!-- Line 280 in js/jquery.multiscroll.js is the place to select the anchor scrolling to the section of your choice -->
						<!-- The data-target value is for mobile devices -->
						<a id="button-more" data-target="right2" class="light-btn open-anim opacity-0">Więcej informacji</a>

						</div>

					<!-- Scroll indicator -->
					<div class="scroll-indicator">

						<!-- Line 280 in js/jquery.multiscroll.js is the place to select the anchor scrolling to the section of your choice -->
						<!-- The data-target value is for mobile devices -->
						<a id="indicator-scroll" data-target="right2"><i class="icon ion-ios-arrow-down"></i></a>
					</div>
				</div>
				<!-- +++ END - Home Left +++ -->

				<!-- +++ START - About Left +++ -->
				<div class="ms-section" id="left2">

					<div id="invert-slideshow" class="slideshow-about"></div>

				</div>
				<!-- +++ END - About Left +++ -->

				<!-- +++ START - Services Left +++ -->
				<div class="ms-section" id="left3">

					<div class="text-left-block">

						<div class="left-center-text split-section">

							<div class="left-center-part">

								<h2>WYKONUJEMY BADANIA:</h2>

								<!-- <p>It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life.</p> -->

								<!-- +++ START - Carousel +++ -->

				                			<!-- START - Services row -->
											<div class="row">

												<!-- START - Block services -->
												<div class="col-xs-12 col-sm-6 col-lg-6 block-services">

													<h3>Kierowców zawodowych oraz amatorów:</h3>

													<ul>
														<li>kierowców prowadzących samochód w celach służbowych (np. przedstawiciele handlowi), jak i zawodowych w ramach wszystkich kategorii prawa jazdy</li>
														<li>kierowców pojazdów uprzywilejowanych</li>
														<li>egzaminatorów nauki jazdy</li>
														<li>instruktorów nauki jazdy</li>
														<li>kandydatów na kierowców oraz kandydatów na instruktorów i egzaminatorów</li>
													</ul>
												</div> <!-- END - Block services -->

												<!-- START - Block services -->
												<div class="col-xs-12 col-sm-6 col-lg-6 block-services" >

													<h3>Kierowców skierowanych na badania na wniosek lekarza lub Wydziału Komunikacji:</h3>

													<ul>
														<li>kierowców skierowanych na badania w wyniku przekroczenia 24 punktów karnych</li>
														<li>osób prowadzących pojazd w stanie nietrzeźwości lub po użyciu środka działającego podobnie do alkoholu</li>
														<li>kierujących skierowanych przez lekarza, jeżeli w wyniku badania lekarskiego stwierdzona zostanie konieczność przeprowadzenia badania psychologicznego</li>
														<li>sprawców wypadków drogowych</li>
													</ul>
												</div> <!-- END - Block services -->

											</div> <!-- END - Services row -->

							        <!-- END - Wrapper for carousel items -->

							    <!-- +++ END - Carousel +++ -->
								<h3>Oferujemy Również:</h3>
									<ul>
										<li>poradnictwo i wsparcie psychologiczne</li>
										<li>diagnozę psychologiczną</li>
										<li>przygotowanie opini psychologicznych po wypadkach komunikacyjnych</li>
										<li>profesjonalną pomoc PSYCHOTRAUMATOLOGA dla osób które doświadczyły traumy np. w wypadkach komunikacyjnych lub innych zdarzeniach losowych <strong>(NOWOŚĆ)</strong></li>
									</ul>
						    </div>

						</div>

					</div>

				</div>
				<!-- +++ END - Services Left +++ -->
				<div class="ms-section" id="left4">
					<div class="text-left-block">
						<div class="left-center-text split-section">
							<div class="left-center-part">
							<h2>CENNIK:</h2>
							<div class="row">
								<div class="col-12 col-lg-6">
									<table id="price">
									<tr>
										<th><strong>BADANIA Z PSYCHOLOGII TRANSPORTU</strong></th>
										<th></th>
									</tr>
									<tr>
										<td>Kierowcy zawodowi</td>
										<td>150,00zł</td>
									</tr>
									<tr>
										<td>Kandydaci na kierowców i osoby przedłużające termin ważności prawo jazdy kat. C, C+E, D, D+E</td>
										<td>150,00zł</td>
									</tr>
									<tr>
										<td>Instruktorzy i egzaminatorzy nauki jazdy (także kandydaci)</td>
										<td>150,00zł</td>
									</tr>
									<tr>
										<td>Kierowcy pojazdów uprzywilejowanych</td>
										<td>150,00zł</td>
									</tr>
									<tr>
										<td>Kierowcy po zatrzymaniu prawo jazdy - kierowanie w stanie nietrzeźwości, przekroczenie limitu punktów karnych lub spowodowanie wypadku drogowego</td>
										<td>150,00zł</td>
									</tr>
									<tr>
										<td>Kierowcy taxi</td>
										<td>150,00zł</td>
									</tr>
									</table>
								</div>
								<div class="col-12 col-lg-6">
									<table id="price">
									<tr>
										<th><strong>BADANIA NA BROŃ</strong></th>
										<th></th>
									</tr>
									<tr>
										<td>Osoby ubiegające się o pozwolenie na broń lub przedłużające jego ważność</td>
										<td>250,00zł</td>
									</tr>
									<tr>
										<td>Strażnicy miejscy</td>
										<td>100,00zł</td>
									</tr>
									<tr>
										<td>Pracownicy ochrony fizycznej</td>
										<td>100,00zł</td>
									</tr>
									<tr>
										<td>Detektywi</td>
										<td>150,00zł</td>
									</tr>
									<tr>
										<td>Inspektorzy Transportu Drogowego</td>
										<td>150,00zł</td>
									</tr>
									<tr>
										<td>Osoby sprzedające broń i amunicję lub pracujące przy jej wytwarzaniu</td>
										<td>150,00zł</td>
									</tr>
									<tr>
										<td>Sędziowie, prokuratorzy, kuratorzy sądowi</td>
										<td>150,00zł</td>
									</tr>
									</table>

								</div>

							</div>
						</div>
						</div>
					</div>
				</div>

				<!-- +++ START - Portfolio Left +++ -->
				<div class="ms-section" id="left5">

					<div class="portfolio my-gallery" itemscope itemtype="http://schema.org/ImageGallery">

		                <!-- 1 -->
		                <figure class="col-xs-12 col-sm-6 col-lg-6" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">

		                    <a href="img/gallery-1.jpeg" class="gallery-link small" data-image="img/gallery-1.jpeg" itemprop="contentUrl" data-size="1920x1280">

		                        <img src="img/gallery-1.jpeg" itemprop="thumbnail" alt="This is my work" class="img-responsive gallery-img small-square" />

		                    </a>

		                    <figcaption itemprop="caption description">

		                        <div class="photo-details">

								 	<h4>Nasze biuro <small>w centrum Piotrkowa</small></h4>
		                            <!-- <h4>Get in the Game <small>Creative from Berlin</small></h4> -->


		                        </div>

		                    </figcaption>

		                </figure>

		                <!-- 2 -->
		                <figure class="col-xs-12 col-sm-6 col-lg-6" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">

		                    <a href="img/gallery-2.jpeg" class="gallery-link small" data-image="img/gallery-2.jpeg" itemprop="contentUrl" data-size="1920x1280">

		                        <img src="img/gallery-2.jpeg" itemprop="thumbnail" alt="This is my work" class="img-responsive gallery-img small-square" />

		                    </a>

		                    <figcaption itemprop="caption description">

		                        <div class="photo-details">

                              <h4>Nasze biuro <small>w centrum Piotrkowa</small></h4>

		                            <!-- <p>Urządzenia do prowadzenia badań.</p> -->

		                        </div>

		                    </figcaption>

		                </figure>

		                <!-- 3 -->
		                <figure class="col-xs-12 col-sm-6 col-lg-6" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">

		                    <a href="img/gallery-3.jpeg" class="gallery-link small" data-image="img/gallery-3.jpeg" itemprop="contentUrl" data-size="1920x1280">

		                        <img src="img/gallery-3.jpeg" itemprop="thumbnail" alt="This is my work" class="img-responsive gallery-img small-square" />

		                    </a>

		                    <figcaption itemprop="caption description">

		                        <div class="photo-details">

                              <h4>Nasze biuro <small>w centrum Piotrkowa</small></h4>
		                        </div>

		                    </figcaption>

		                </figure>

		                <!-- 4 -->
		                <figure class="col-xs-12 col-sm-6 col-lg-6" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">

		                    <a href="img/gallery-4.jpeg" class="gallery-link small" data-image="img/gallery-4.jpeg" itemprop="contentUrl" data-size="1920x1280">

		                        <img src="img/gallery-4.jpeg" itemprop="thumbnail" alt="This is my work" class="img-responsive gallery-img small-square" />

		                    </a>

		                    <figcaption itemprop="caption description">

		                        <div class="photo-details">

		                        <h4>Urządzenie diagnostyczne.</h4>
	                            <!-- <h4>Get in the Game <small>Creative from Berlin</small></h4>

		                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p> -->

		                        </div>

		                    </figcaption>

		                </figure>

		                <!-- 5 -->
		                <figure class="col-xs-12 col-sm-6 col-lg-6" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">

		                    <a href="img/gallery-5.jpeg" class="gallery-link small" data-image="img/gallery-5.jpeg" itemprop="contentUrl" data-size="1920x1280">

		                        <img src="img/gallery-5.jpeg" itemprop="thumbnail" alt="This is my work" class="img-responsive gallery-img small-square" />

		                    </a>

		                    <figcaption itemprop="caption description">

		                        <div class="photo-details">

		                            <h4>Urządzenie diagnostyczne.</h4>
		                        </div>

		                    </figcaption>

		                </figure>

		                <!-- 6 -->
		                <figure class="col-xs-12 col-sm-6 col-lg-6" itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">

		                    <a href="img/gallery-6.jpeg" class="gallery-link small" data-image="img/gallery-6.jpeg" itemprop="contentUrl" data-size="1920x1280">

		                        <img src="img/gallery-6.jpeg" itemprop="thumbnail" alt="This is my work" class="img-responsive gallery-img small-square" />

		                    </a>

		                    <figcaption itemprop="caption description">

		                        <div class="photo-details">

		                          	<h4>Nasze biuro <small>w centrum Piotrkowa</small></h4>
		                        </div>

		                    </figcaption>

		                </figure>

		            </div>

				</div>
				<!-- +++ END - Portfolio Left +++ -->

				<!-- +++ START - Contact Left +++ -->
				<div class="ms-section" id="left6">

					<div class="text-left-block">

						<div class="left-center-text split-section">

							<div class="left-center-part">

								<h2 style="text-align:center;">SKONTAKTUJ SIĘ Z NAMI</h2>

		                		<address style="text-align: center;font-size: 1.7rem;line-height: 1.8;">
								<strong>97-300 Piotrków Trybunalski</strong><br>
								ul. Narutowicza 94 lokal 8<br>
								<abbr title="Phone">Tel:</abbr> <a href="tel:691120600">691 120 600</a>
								</address>
								<address  style="text-align: center;font-size: 1.7rem;line-height: 1.8;">
								<strong>Email</strong><br>
								<a href="mailto:profil@onet.eu">profil@onet.eu</a>
								</address>

								<p class="copyright">©Centrum Psychologii Pracy Profil - Wszystkie Prawa Zastrzeżone</p>

							</div>

						</div>

					</div>

				</div>
				<!-- +++ END - Contact Left +++ -->

			</div>
			<!-- CLOSE - LEFT PART -->

			<!-- OPEN - RIGHT PART -->
			<div class="ms-right" id="right-part">

				<!-- +++ START - Home Right +++ -->
				<div class="ms-section" id="right1">

					<!-- Background slideshow & light overlay -->
					<div class="slideshow-home-right">
						<div class="slideshow-overlay-right"></div>
					</div>

				</div>
				<!-- +++ END - Home Right +++ -->

				<!-- +++ START - About Right +++ -->
				<div class="ms-section" id="right2">

					<div class="text-left-block">

						<div id="invert-text" class="left-center-text split-section">

							<div class="left-center-part">

								<h2>O NAS</h2>

								<p>Skoro jesteś na naszej stronie, oznacza, że potrzebujesz wykonać psychotesty lub szukasz profesjonalnej porady psychologicznej. Mamy dobrą wiadomość – to idealne miejsce dla Ciebie. Posiadamy wieloletnie doświadczenie, które pozwala nam świadczyć profesjonalne usługi na najwyższym poziomie. Naszą dewizą jest ciągłe doskonalenie, dlatego nieustannie poszerzamy kwalifikacje, wiedzę i zakres oferowanych usług. Pewnie wielokrotnie czytałeś podobne informacje na innych stronach, dlatego nie będziemy Cię dłużej namawiać by skorzystać z naszych usług – przyjdź i przekonaj się, że warto.</p>
								<br>
								<p>Zapewniamy dogodne terminy badań - od <strong>poniedziałku do piątku w godz. 8:00 - 20:00 oraz w soboty</strong>. Termin i godzinę badania prosimy wcześniej ustalić telefonicznie, e-mailowo bądź osobiście. Nowoczesna aparatura diagnostyczna pozwala skrócić czas badania.</p>
								<p>Stosujemy testy rekomendowane przez <strong>Polskie Towarzystwo Psychologiczne</strong>.<p>
								<br>
								<p>Współpracujemy z lekarzami medycyny pracy, przez co możesz wykonać wszystkie badania w jeden dzień.</p>
							</div>

						</div>

					</div>

				</div>
				<!-- +++ END - About Right +++ -->

				<!-- +++ START - Services Right +++ -->
				<div class="ms-section" id="right3">

						<div class="text-left-block">

						<div class="left-center-text split-section">

							<div class="left-center-part">

								<!-- <p>It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life.</p> -->

				                			<!-- START - Services row -->
											<div class="row">

												<!-- START - Block services -->
												<div class="col-xs-12 col-sm-6 col-lg-6 block-services" >

													<h3>Operatorów i osób zatrudnionych na stanowiskach wymagających pełnej sprawności psychoruchowej:</h3>
													<ul>
														<li>operatorów wszelkiego rodzaju sprzętu budowlanego, ciężkiego (np. koparek, dźwigów), wózków widłowych, żurawi, suwnic i innego sprzętu</li>
														<li>osób pracujących na wysokości</li>
													</ul>

												</div> <!-- END - Block services -->

												<!-- START - Block services -->
												<div class="col-xs-12 col-sm-6 col-lg-6 block-services" >

													<h3>Badania psychologiczne na broń: </h3>
													<ul>
														<li>osób ubiegających się o pozwolenie na broń i osób posiadających broń</li>
														<li>strażników miejskich</li>
														<li>detektywów i kandydatów na detektywów</li>
														<li>inspektorów i kandydatów na inspektorów transportu drogowego</li>
														<li>osób ubiegających się o wpis/wpisane na listę kwalifikowanego pracownika ochrony fizycznej</li>
														<li>kandydatów na objęcie stanowiska sędziego, prokuratora, kuratora sądowego, komornika</li>
														<li>osób zatrudnionych przy wytwarzaniu/obrocie bronią i materiałami niebezpiecznymi</li>
													</ul>

												</div> <!-- END - Block services -->

											</div> <!-- END - Services row -->

							    <!-- +++ END - Carousel +++ -->
						    </div>

						</div>

					</div>

				</div>
				<!-- +++ END - Services Right +++ -->
				<div class="ms-section" id="right4">
						<div class="text-left-block">
						<div class="left-center-text split-section">
							<div class="left-center-part">
							<div class="row">
								<div class="col-12 col-lg-6">
									<table id="price">
									<tr>
										<th><strong>BADANIA Z MEDYCYNY PRACY</strong></th>
										<th></th>
									</tr>
									<tr>
										<td>Operatorzy maszyn (m.in. wózki jezdniowe, koparki, ładowarki, podesty, żurawie, praca na wysokości)</td>
										<td>90,00zł</td>
									</tr>
									<tr>
										<td>Kierowcy kat. B (pełna sprawność psychofizyczna)</td>
										<td>110,00zł</td>
									</tr>
									<tr>
										<td>Badanie widzenia zmierzchowego i wrażliwości na olśnienie</td>
										<td>40,00zł</td>
									</tr>
									</table>
									</div>
									<div class="col-12 col-lg-6">
									<table id="price" >
									<tr>
										<th><strong>POZOSTAŁE BADANIA I USŁUGI</strong></th>
										<th></th>
									</tr>
									<tr>
										<td>Konsultacja psychologiczna - 60 min.</td>
										<td>150,00zł</td>
									</tr>
									<tr>
										<td>Konsultacja psychotraumatologa - 60 min.</td>
										<td>150,00zł</td>
									</tr>
									<tr>
										<td>Badanie psychologiczne do grupy (łącznie z opinią)</td>
										<td>200,00zł</td>
									</tr>
									<tr>
										<td>Diagnoza osobowości, temperamentu, sprawności intelektualnej, stylów radzenia sobie ze stresem, stylów przywiązania, poziomu lęku, agresji, zasobów uwagi, depresji, deficytów neuropsychologicznych</td>
										<td>80,00 zł - 200 zł (w zależności od zakresu)</td>
									</tr>
									<tr>
										<td>Diagnoza po wypadkach w kierunku określenia aktualnego poziomu funkcjonowania, również pod kątem diagnozy PTSD</td>
										<td>200,00zł</td>
									</tr>
									</table>
								</div>

							</div>
						</div>
						</div>
					</div>
				</div>
				<!-- +++ START - Portfolio Right +++ -->
				<div class="ms-section" id="right5">

					<div class="text-left-block">

						<div class="left-center-text split-section">

							<div class="left-center-part">
								<h2>PRZYGOTOWANIE</h2>
								<div>
									<h3>Co należy zabrać na badanie:</h3>
									<ul >
										<li>dokument tożsamości (prawo jazdy, dowód osobisty lub paszport).</li>
										<li>aktualne okulary bądź soczewki kontaktowe jeśli używamy</li>
										<li>skierowanie na badanie psychologiczne (jeśli zostało wystawione)</li>
										<p>Ważne, by na badanie zgłosić się <strong>wypoczętym, wyspanym, na 48 godzin przed badaniem nie spożywać alkoholu, ani innych środków, mogących wpływać na sprawność psychofizyczną.</strong></p>
									</ul>
								</div>
								<div>
									<h3 style="margin-top: 1.5rem;">Pliki:</h3>
									<ul >
										<li>skierowanie dla operatorów  pobierz <a href="documents/skierowanie_operatorzy.pdf" target="_blank">tutaj</a></li>
										<li>skierowanie dla kierowców zawodowych pobierz <a href="documents/skierowanie.pdf"  target="_blank"> tutaj </a></li>
										<li>skierowanie dla strażników miejskich <a href="documents/skieorwaniestraznik.doc"  target="_blank"> tutaj </a></li>
									</ul>
								</div>
								<div>
									<h3 style="margin-top: 1.5rem;">Linki:</h3>
									<ul >
										<!-- <li>Działanie alkoholu na ludzki organizm: <a href="http://www.wyhamujwpore.pl/Articles/view/23/Jak-dziala-alkohol" target="_blank">kampania Wyhamuj w porę!</a></li> -->
										<li>Znaczenie prędkości w ruchu drogowym: <a href="http://www.krbrd.gov.pl" target="_blank">strona Krajowej Rady BRD</a></li>
									</ul>
								</div>

								<!-- START - Team -->
								<!-- END - Team -->

							</div>

						</div>

					</div>

				</div>
				<!-- +++ END - Portfolio Right +++ -->

				<!-- +++ START - Contact Right +++ -->
				<div class="ms-section" id="right6">

          <iframe style="width: -webkit-fill-available;height: -webkit-fill-available;" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Gabriela%20Narutowicza%2094,%20Piotrk%C3%B3w%20Trybunalski+(Centrum%20Psychologii%20Pracy%20PROFIL)&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.maps.ie/distance-area-calculator.html">distance maps</a></iframe>

					<!-- <div class="map-info split-section"> -->
						<!-- <div id="map"></div> -->
					<!-- </div> -->

				</div>
				<!-- +++ END - Contact Right +++ -->

			</div>
			<!-- CLOSE - RIGHT PART -->

		</div>

    <div id="info">

			<!-- Cross to close the Newsletter panel on top right -->
			<button class="close-newsletter"><i class="icon ion-close-round"></i></button>

			<div class="content">

				<!-- Your logo -->
        		<img src="img/logo3.png" alt="Centrum Psychologii Pracy Profil" class="brand-logo" />
					<address style="text-align: center;font-size: 1.7rem;line-height: 1.8; color:black;">
					<strong>97-300 Piotrków Trybunalski</strong><br>
					ul. Narutowicza 94 lokal 8<br>
					<abbr title="Phone">Tel:</abbr> <a style="color:black" href="tel:691120600">691 120 600</a>
					</address>
					<address  style="text-align: center;font-size: 1.7rem;line-height: 1.8; color:black">
					<strong>Email</strong><br>
					<a style="color:black"  href="mailto:profil@onet.eu">profil@onet.eu</a>
					</address>
                <!-- <p class="subtitle">Sign up to the PURE News before our launching on the 14th of August for the chance to <strong>win a fabulous space flight into outer space for you & the person of your choice!</strong></p> -->

                <!-- START - Newsletter Form -->

    			<!-- END - Newsletter Form -->

			</div>

			<!-- Answer for the newsletter form is displayed in the next div, do not remove it. -->
			<div class="block-message">

				<div class="message">

					<p class="notify-valid"></p>

				</div>

			</div>

			<!-- <p class="spam-news"><i class="fa fa-lock"></i> We hate spam just as much as you do. Your email will stay secret.</p> -->

		</div>
		<!-- +++ END - Newsletter panel +++ -->

		<!-- +++ Button used for opening the newsletter panel +++ -->
		<a id="open-newsletter" class="action-btn">NOWY ADRES: ul. Narutowicza 94 lokal 8</a>

		<!-- +++ List of social media on the bottom right +++ -->
		<div id="social-nav">

			<ul>
				<!-- Facebook -->
				<li>
					<a href="https://www.facebook.com/Centrum-Psychologii-Pracy-Profil-117322991792156" target="_blank"><i class="fa fa-facebook"></i></a>
				</li>

				<!-- Linkedin -->
				<!-- <li>
					<a href="#" target="_blank"><i class="fa fa-linkedin"></i></a>
				</li> -->

			</ul>

		</div>

		<!-- Root element of PhotoSwipe, the gallery. Must have class pswp. -->
		<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

		    <!-- Background of PhotoSwipe.
	        	It's a separate element as animating opacity is faster than rgba(). -->
		    <div class="pswp__bg"></div>

		    <!-- Slides wrapper with overflow:hidden. -->
		    <div class="pswp__scroll-wrap">

		        <!-- Container that holds slides.
		            PhotoSwipe keeps only 3 of them in the DOM to save memory.
		            Don't modify these 3 item elements, data is added later on. -->
		        <div class="pswp__container">
		            <div class="pswp__item"></div>
		            <div class="pswp__item"></div>
		            <div class="pswp__item"></div>
		        </div>

		        <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
		        <div class="pswp__ui pswp__ui--hidden">

		            <div class="pswp__top-bar">

		                <!--  Controls are self-explanatory. Order can be changed. -->

		                <div class="pswp__counter"></div>

		                <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

		                <button class="pswp__button pswp__button--share" title="Share"></button>

		                <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

		                <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

		                <!-- Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR -->
		                <div class="pswp__preloader">
		                    <div class="pswp__preloader__icn">
		                      <div class="pswp__preloader__cut">
		                        <div class="pswp__preloader__donut"></div>
		                      </div>
		                    </div>
		                </div>

		            </div>

		            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
		                <div class="pswp__share-tooltip"></div>
		            </div>

		            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
		            </button>

		            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
		            </button>

		            <div class="pswp__caption">
		                <div class="pswp__caption__center"></div>
		            </div>

		        </div>

		    </div>

		</div>
		<cookie-law :buttonText="'Zaakceptuj'" :buttonClass="'cookie-button'">
        <div slot="message" >
            Ta strona wykorzystuję piliki cookies do prawidłowego działania. Szczegóły znajdziesz w naszej  <a style="color:black" @click="$modal.show('polityka-prywatnosci')" to="polityka-prywatnosci" >polityca prywatności</a>. Wyrażam zgodę na wykorzystywanie plików cookies.
        </div>
		</cookie-law>
		<modal name="polityka-prywatnosci" height="auto" :scrollable="true">
			<div class="cookie-container" >
				<h3 style="color: black;">Polityka Prywatności</h3>
				<p style="color: black;">1. Serwis nie zbiera w sposób automatyczny żadnych informacji, z wyjątkiem informacji zawartych w plikach cookies.</p>
				<p style="color: black;">2. Pliki cookies (tzw. „ciasteczka”) stanowią dane informatyczne, w szczególności pliki tekstowe, które
				przechowywane są w urządzeniu końcowym Użytkownika Serwisu i przeznaczone są do korzystania ze
				stron internetowych Serwisu. Cookies zazwyczaj zawierają nazwę strony internetowej, z której pochodzą,
				czas przechowywania ich na urządzeniu końcowym oraz unikalny numer.</p>
				<p style="color: black;">3. Podmiotem zamieszczającym na urządzeniu końcowym Użytkownika Serwisu pliki cookies oraz
				uzyskującym do nich dostęp jest operator Serwisu Centrum Psychologii Pracy "Profil" Anna Stępień z
				siedzibą przy ulicy Młynarskiej 2 w Piotrkowie Trybunalskim.</p>
				<p style="color: black;">4. Pliki cookies wykorzystywane są w celu:
				- dostosowania zawartości stron internetowych Serwisu do preferencji Użytkownika oraz optymalizacji
				korzystania ze stron internetowych; w szczególności pliki te pozwalają rozpoznać urządzenie
				Użytkownika Serwisu i odpowiednio wyświetlić stronę internetową, dostosowaną do jego
				indywidualnych potrzeb;
				- tworzenia statystyk, które pomagają zrozumieć, w jaki sposób Użytkownicy Serwisu korzystają ze stron
				internetowych, co umożliwia ulepszanie ich struktury i zawartości;</p>
				<p style="color: black;">5. 5. W ramach Serwisu stosowane są następujące rodzaje plików cookies:
- „niezbędne” pliki cookies, umożliwiające korzystanie z usług dostępnych w ramach Serwisu, np.
uwierzytelniające pliki cookies wykorzystywane do usług wymagających uwierzytelniania w ramach
Serwisu;
- pliki cookies służące do zapewnienia bezpieczeństwa, np. wykorzystywane do wykrywania nadużyć w
zakresie uwierzytelniania w ramach Serwisu;
- „wydajnościowe” pliki cookies, umożliwiające zbieranie informacji o sposobie korzystania ze stron
internetowych Serwisu;
- „funkcjonalne” pliki cookies, umożliwiające „zapamiętanie” wybranych przez Użytkownika ustawień i
personalizację interfejsu Użytkownika, np. w zakresie wybranego języka lub regionu, z którego pochodzi
Użytkownik, rozmiaru czcionki, wyglądu strony internetowej itp.;
- „reklamowe” pliki cookies, umożliwiające dostarczanie Użytkownikom treści reklamowych bardziej
dostosowanych do ich zainteresowań.</p>
				<p style="color: black;">6. W wielu przypadkach oprogramowanie służące do przeglądania stron internetowych (przeglądarka
internetowa) domyślnie dopuszcza przechowywanie plików cookies w urządzeniu końcowym
Użytkownika. Użytkownicy Serwisu mogą dokonać w każdym czasie zmiany ustawień dotyczących
plików cookies. Ustawienia te mogą zostać zmienione w szczególności w taki sposób, aby blokować
automatyczną obsługę plików cookies w ustawieniach przeglądarki internetowej bądź informować o ich
każdorazowym zamieszczeniu w urządzeniu Użytkownika Serwisu. Szczegółowe informacje o
możliwości i sposobach obsługi plików cookies dostępne są w ustawieniach oprogramowania
(przeglądarki internetowej).</p>
				<p style="color: black;">7. Operator Serwisu informuje, że ograniczenia stosowania plików cookies mogą wpłynąć na niektóre
funkcjonalności dostępne na stronach internetowych Serwisu.</p>
<p style="color: black;">Poniższy wzór polityki cookies chroniony jest prawem autorskim, które przysługują IAB Polska.
źródło: https://wszystkoociasteczkach.pl/.</p>
			</div>
		</modal>
  </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law';

export default {
  name: 'App',
  components: {
    CookieLaw
  }
}
</script>

<style>
.cookie-button{
	  color: #2b1870;
}
.cookie-container{
	padding: 1rem;

}
/* #price {
  border-collapse: collapse;
  width: 100%;
}

#price td, #price th {
  border: 1px solid #ddd;
  padding: 8px;
} */
#price td, #price th {
  border: 1px solid #ddd;
padding: 2px;
}

h2{
	font-size: 3rem;;
}
</style>
